import React from 'react';
import { getAssets } from 'themes/assets';
import { _t } from 'utils';
import Shared from 'screens/shared';
import moment from 'moment';
import { Link } from 'react-router-dom';

import Storages from './storages';
import NICs from './nics';

export default ({ history, server }) => {
  const assets = getAssets();
  const {
    properties = {}, metadata = {}, entities = {}, href = '',
  } = server;
  const { volumes = {}, nics = {} } = entities;
  const { items: volumesItems = [] } = volumes;
  const { items: nicsItems = [] } = nics;
  // const { items: cdromsItems = [] } = cdroms;

  const managedBy = metadata.createdBy === '[K8S]' ? (
    <img src={assets.KubernatesLogo} alt="kubernates logo" className="kubernates-logo" />
  ) : _t('Manual');

  const propertiesRows = [
    [_t('Managed By'), managedBy],
    [_t('Availability Zone'), properties.availabilityZone],
    [_t('CPU Family'), properties.cpuFamily],
    [_t('RAM'), `${properties.ram / 1024}GB`],
    [_t('Cores'), properties.cores],
    [_t('Last Updated'), moment(metadata.lastModifiedDate).fromNow()],
  ];

  return (
    <>
      <section className="screen-server">
        <div className="strap">
          <div className="strap-details">
            <span className={`strap-details-square status-background-${properties.vmState}`} />
            <span className="strap-details-name">{properties.vmState}</span>
          </div>
          <Link to={`/server?serverUrl=${href}`} style={{ textDecoration: 'none' }}>
            <div className="strap-details-icons">
              <span className="strap-details-icons-text">Control</span>
              <Shared.widgets.Icon name="chevron-right" />
            </div>
          </Link>
        </div>

        <Shared.widgets.Properties properties={propertiesRows} />
        {!!volumesItems.length && (
          <Storages storages={volumesItems} history={history} />
        )}
        {!!nicsItems.length && (
          <NICs nics={nicsItems} history={history} />
        )}
      </section>
    </>
  );
};
